<div>
    <p-dropdown [styleClass]="isValid()" [options]="models" (onChange)="change($event)" [(ngModel)]="value" optionLabel="model" placeholder="{{placeholder}}" [disabled]="disabled" [required]="required">
    </p-dropdown>
</div>